import { ofType, combineEpics } from 'redux-observable';
import { mergeMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { startWithEndWith, NO_OP } from 'middleware/utils';
import {
  toggleGroupListLoading,
} from 'store/groupList/actions';
import {
  getGroupDeviceData,
} from 'middleware/data/actions';
import {
  getFamilyListSuccess,
} from 'store/notification/actions';
import {
  UPDATE_FAMILY_ITEM,
  LIST_ALL_FAMILY,
  listAllFamily,
} from './actions';

const updateFamilyItemEpic = (action$, state$, { familyRequest }) => action$.pipe(
  ofType(UPDATE_FAMILY_ITEM),
  mergeMap((params) => {
    const { payload } = params;
    const { id, family, activeKey } = payload;
    return familyRequest.updateFamilyItem$(id, family).pipe(
      mergeMap(() => of(
        getGroupDeviceData(activeKey),
        listAllFamily(),
      )),
      catchError(() => of(NO_OP)),
      startWithEndWith(toggleGroupListLoading(true), toggleGroupListLoading(false)),
    );
  }),
  catchError(() => of(NO_OP)),
);

const getAllFamilyList = (action$, state$, { familyRequest }) => action$.pipe(
  ofType(LIST_ALL_FAMILY),
  mergeMap(() => familyRequest.getAllFamilyList$().pipe(
    mergeMap((response) => {
      const { data } = response;
      return of(getFamilyListSuccess(data));
    }),
    catchError(() => of(NO_OP)),
    startWithEndWith(toggleGroupListLoading(true), toggleGroupListLoading(false)),
  )),
  catchError(() => of(NO_OP)),
);

export default combineEpics(
  updateFamilyItemEpic,
  getAllFamilyList,
);
